import React, { useEffect, useState } from "react";
import { Button, Spinner } from "@ui";
import TextareaAutosize from "react-textarea-autosize";
import {
  useSystemPrompt,
  useUpdateSystemPrompt,
} from "@agentic_system/api/system-prompt";

interface SystemPromptEditorProps {
  promptType: string;
}

export function SystemPromptEditor({ promptType }: SystemPromptEditorProps) {
  const { data: systemPrompt, isLoading } = useSystemPrompt(promptType);
  const updateSystemPrompt = useUpdateSystemPrompt(promptType);
  const [content, setContent] = useState("");

  useEffect(() => {
    setContent(systemPrompt?.content ?? "");
  }, [systemPrompt]);

  const handleSave = async () => {
    await updateSystemPrompt.mutateAsync(content);
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {/* Custom prompt (editable) */}
      <div className="space-y-1">
        <p className="text-xs text-slate-500 font-medium">
          Prompt personnalisé (ajouté à la suite)
        </p>
        <TextareaAutosize
          value={content}
          onChange={(e) => setContent(e.target.value)}
          minRows={6}
          className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm font-mono focus:outline-none focus:ring-2 focus:ring-default-500 focus:border-default-500 resize-none"
          placeholder="Entrez votre prompt système personnalisé..."
        />
      </div>

      {/* Save button */}
      <div className="flex justify-end">
        <Button
          onClick={handleSave}
          loading={updateSystemPrompt.isPending}
          disabled={!content.trim()}
        >
          Enregistrer
        </Button>
      </div>

      {/* Default system prompt (read-only) */}
      <div className="space-y-1">
        <p className="text-xs text-slate-500 font-medium">
          Prompt système par défaut (non modifiable)
        </p>
        <pre className="w-full px-3 py-2 bg-slate-50 border border-slate-200 rounded-lg text-xs font-mono text-slate-600 opacity-70 overflow-auto whitespace-pre-wrap">
          {systemPrompt?.default_prompt}
        </pre>
      </div>
    </div>
  );
}
